import {combineValidators, required, isEmail, isPhone, maxLength, isValidString} from "../Validators";

export const ContactFormScheme = {
  email: combineValidators(required, isEmail, isValidString),
  phone: combineValidators(required, isPhone),
  firstName: combineValidators(required, isValidString),
  lastName: combineValidators(required, isValidString),
  message: combineValidators(required, maxLength(500)),
};